const DASHBOARD_OVERVIEW_CACHE_KEY = "menusano.dashboard.v2.overview";

export type DashboardOverviewCachePayload<TData> = {
  restaurantId: number | null;
  userId: number | null;
  cachedAt: string;
  data: TData;
};

export function loadDashboardOverviewCache<TData>(restaurantId?: number | null, userId?: number | null) {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(DASHBOARD_OVERVIEW_CACHE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as DashboardOverviewCachePayload<TData>;
    if (!parsed || parsed.restaurantId !== (restaurantId ?? null) || parsed.userId !== (userId ?? null)) {
      return null;
    }

    return parsed;
  }
  catch {
    return null;
  }
}

export function saveDashboardOverviewCache<TData>(payload: DashboardOverviewCachePayload<TData>) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(DASHBOARD_OVERVIEW_CACHE_KEY, JSON.stringify(payload));
}
